/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserTournamentTeam } from './UserTournamentTeam';
import {
    UserTournamentTeamFromJSON,
    UserTournamentTeamFromJSONTyped,
    UserTournamentTeamToJSON,
    UserTournamentTeamToJSONTyped,
} from './UserTournamentTeam';

/**
 * 
 * @export
 * @interface UserTournamentTeamsResponse
 */
export interface UserTournamentTeamsResponse {
    /**
     * 
     * @type {Array<UserTournamentTeam>}
     * @memberof UserTournamentTeamsResponse
     */
    teams: Array<UserTournamentTeam>;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentTeamsResponse
     */
    total: number;
}

/**
 * Check if a given object implements the UserTournamentTeamsResponse interface.
 */
export function instanceOfUserTournamentTeamsResponse(value: object): value is UserTournamentTeamsResponse {
    if (!('teams' in value) || value['teams'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function UserTournamentTeamsResponseFromJSON(json: any): UserTournamentTeamsResponse {
    return UserTournamentTeamsResponseFromJSONTyped(json, false);
}

export function UserTournamentTeamsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTournamentTeamsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teams': ((json['teams'] as Array<any>).map(UserTournamentTeamFromJSON)),
        'total': json['total'],
    };
}

export function UserTournamentTeamsResponseToJSON(json: any): UserTournamentTeamsResponse {
    return UserTournamentTeamsResponseToJSONTyped(json, false);
}

export function UserTournamentTeamsResponseToJSONTyped(value?: UserTournamentTeamsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teams': ((value['teams'] as Array<any>).map(UserTournamentTeamToJSON)),
        'total': value['total'],
    };
}

